import React, { useState } from "react";
import SpinnerComponent from "../../../components/SpinnerComponent";
import useUnitData from "../../products/UnitData";
import Leftpanel from "../../layout/Leftpanel";
import Header from "../../layout/Header";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";

const UnitsOfMeasure = () => {
  const { t } = useTranslation();
  const PER_PAGE = 10;
  const unitData = useUnitData();
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setLoading] = useState(false);

  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const offset = currentPage * PER_PAGE;

  const currentPageData = unitData
    ?.slice(offset, offset + PER_PAGE)
    ?.map((ele, i) => (
      <tr id={`row-${ele._id}`} key={i}>
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
          {ele?.id}
        </td>
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
          {ele?.common_unit}
        </td>
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-4 text-left">
          {ele?.other_unit}
        </td>
      </tr>
    ));

  const pageCount = Math.ceil(unitData?.length / PER_PAGE);

  return (
    <div className="container-fluid">
      <div className="dbMain ghgbg">
        <Leftpanel breadcm="Other" />
        <div className="dbRight">
          <Header
            link="/dashboard"
            title={t("units_of_measures")} // Use translation
            description=""
          />
          <div className="commonBase mb-4">
            <div className="dbMaintable respTable">
              {isLoading && <SpinnerComponent isLoading={isLoading} />}
              <table>
                <thead>
                  <tr>
                    <th>{t("id")}</th>
                    <th>Common Units</th>
                    <th>Other Units</th>
                  </tr>
                </thead>
                <tbody>{unitData?.length !== 0 && currentPageData}</tbody>
              </table>

              {!isLoading && (
                <ReactPaginate
                  previousLabel={t("previous")}
                  nextLabel={t("next")}
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  previousLinkClassName={"pagination__link"}
                  nextLinkClassName={"pagination__link"}
                  disabledClassName={"pagination__link--disabled"}
                  activeClassName={"pagination__link--active"}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnitsOfMeasure;
